import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=1a8ffebc&"
import script from "./Publisher.vue?vue&type=script&lang=js&"
export * from "./Publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8ffebc')) {
      api.createRecord('1a8ffebc', component.options)
    } else {
      api.reload('1a8ffebc', component.options)
    }
    module.hot.accept("./Publisher.vue?vue&type=template&id=1a8ffebc&", function () {
      api.rerender('1a8ffebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScreenSharing/components/Publisher.vue"
export default component.exports